import { appApi } from './app_api';

// Newsletter signup lives on the shared appApi. The logged-in opt-in/decline
// mutations patch the getCurrentUser cache directly (newsletter_subscribed) so
// the first-login popup dismisses immediately without a /users/me refetch.
const patchCurrentUserSubscription = async (value, { dispatch, queryFulfilled }) => {
  const patch = dispatch(
    appApi.util.updateQueryData('getCurrentUser', undefined, (user) => {
      if (user) user.newsletterSubscribed = value;
    })
  );
  try {
    await queryFulfilled;
  } catch {
    patch.undo();
  }
};

export const newsletterApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    // Public, account-less signup from the footer form.
    subscribeNewsletter: builder.mutation({
      query: (email) => ({
        url: '/newsletter_subscriptions',
        method: 'POST',
        body: { email },
      }),
      transformResponse: (response) => response.data,
    }),
    // First-login popup opt-in (captures email; also creates the subscription).
    subscribeNewsletterLoggedIn: builder.mutation({
      query: (email) => ({
        url: '/newsletter_subscriptions/subscribe',
        method: 'POST',
        body: { email },
      }),
      onQueryStarted: (arg, api) => patchCurrentUserSubscription(true, api),
    }),
    // First-login popup decline.
    declineNewsletter: builder.mutation({
      query: () => ({
        url: '/users/newsletter_decline',
        method: 'POST',
      }),
      onQueryStarted: (arg, api) => patchCurrentUserSubscription(false, api),
    }),
  }),
});

export const {
  useSubscribeNewsletterMutation,
  useSubscribeNewsletterLoggedInMutation,
  useDeclineNewsletterMutation,
} = newsletterApi;
